import { Typography } from '@mui/material'
import React from 'react'

const CaptchaCredits = ({sx={}}) => {
  return (
    <Typography
      variant='body2'
      sx={{ fontSize: '11px', color: 'grey.400', ...sx }}
    >
      This site is protected by reCAPTCHA Enterprise and the Google&nbsp;
      <a href='https://policies.google.com/privacy'>Privacy Policy</a> and&nbsp;
      <a href='https://policies.google.com/terms'>Terms of Service</a> apply.
    </Typography>
  )
}

export default CaptchaCredits
